import api from './client';

export const carrierFeedbackService = {
    addFeedback: async (credentials) => {
        const response = await api.post('feedback-evaluations/generate', credentials);
        return response.data;
    },
    getAllFeedback: async () => {
        const response = await api.get('feedback-evaluations');
        return response.data;
    },
    deleteFeedback: async (id) => {
        const response = await api.delete(`feedback-evaluations/${id}`);
        return response.data;
    },


    getAllSuccessStatistics: async () => {
        const response = await api.get('success-placement-statistics');
        return response.data;
    },
    addSuccessStatistics: async (credentials) => {
        const response = await api.post('success-placement-statistics/generate', credentials);
        return response.data;
    },
    deleteSuccessStatistics: async (id) => {
        const response = await api.delete(`success-placement-statistics/${id}`);
        return response.data;
    },

    getQualificationPlan: async () => {
        const response = await api.get('qualifizierungsplan');
        return response.data;
    },
    getQualificationPlanByDate: async ({ start_date, end_date }) => {
        const response = await api.get(`generate-qualifizierungsplan?start_date=${start_date}&end_date=${end_date}`);
        return response.data;
    },
    deleteQualificationPlan: async (id) => {
        const response = await api.delete(`qualifizierungsplan/${id}`);
        return response.data;
    },
    organizationTree: async () => {
        const response = await api.get('organization/tree');
        return response.data;
    },

    // Qualification Matrix
    getAllQualificationMatrix: async () => {
        const response = await api.get('qualification-matrix');
        return response.data;
    },
    deleteQualificationMatrix: async (id) => {
        const response = await api.delete(`qualification-matrix/${id}`);
        return response.data;
    },
    generateQualificationMatrix: async () => {
        const response = await api.post('qualification-matrix');
        return response.data;
    },

    getDocuments: async () => {
        const response = await api.get('documents');
        return response.data;
    },
};